import {
  getIsServerError$,
  setIsServerError$,
  ServerErrorState,
} from '../Observables/ServerError.observable';

export const setIsServerError = (error: ServerErrorState) => {
  setIsServerError$(error);
};

export const getIsServerError = () => {
  return getIsServerError$();
};
